import { getLocales } from '@change-corgi/config/locales';
import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_CAPYBARA_HOMEPAGE_V3 = defineFcm('capybara_homepage_v3')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				perLocaleConfig: {
					type: 'record',
					keys: getLocales(),
					optional: true,
					shape: {
						type: 'object',
						optional: true,
						shape: {
							enabled: { type: 'boolean' },
							sunriseEnabled: { type: 'boolean' },
							layout: {
								type: 'object',
								shape: {
									hero: { type: 'boolean', optional: true },
									howTo: { type: 'boolean', optional: true },
								},
							},
							tips: {
								type: 'array',
								shape: {
									type: 'object',
									shape: {
										title: { type: 'string' },
										guideLink: { type: 'string' },
									},
								},
							},
							topImpactStories: {
								type: 'array',
								shape: {
									type: 'object',
									shape: {
										petitionId: { type: 'string' },
										summary: { type: 'string' },
										imageUrl: { type: 'string' },
										badgeTitle: { type: 'string', optional: true },
										testimonialUrl: { type: 'string', optional: true },
									},
								},
							},
						},
					},
				},
			},
		}),
	)
	.withDefault({
		perLocaleConfig: {},
	})
	.toConfig();
